// @flow

import { createStorageInstance } from 'zapier-async-storage';

import type { Storage } from 'app/common/apollo/types';

const apolloStorage: Storage = createStorageInstance({
  storeName: 'apollo-storage',
  version: 3,
  dbName: 'zapier-storage',
});

export default apolloStorage;
